<template>
  <div class="api-detail-row">
    <span>{{ label }}</span>
    <span class="api-detail-row__value">
      <span class="api-detail-row__text">
        <slot name="value">{{ value }}</slot>
      </span>
      <slot name="action" />
    </span>
  </div>
</template>

<script setup lang="ts">
const { label, value = '' } = defineProps<{
  label: string;
  value?: string;
}>();
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";

.api-detail-row {
  @apply flex items-center justify-between gap-16 text-neutral-text;
}

.api-detail-row__value {
  @apply flex items-center gap-4 min-w-0;
}

.api-detail-row__text {
  @apply min-w-0 truncate;
}
</style>
